import { Box } from '@mui/system'

export default function Error() {
    return <Box>Error</Box>
}
